<template>
  <div class="min-h-screen bg-gray-50">
    <!-- 页面标题 -->
    <div class="bg-white shadow-sm border-b">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="flex items-center justify-between h-16">
          <div>
            <h1 class="text-2xl font-bold text-gray-900">{{ $store.getters.t('video_workbench') }}</h1>
            <p class="text-sm text-gray-600">{{ $store.getters.t('video_workbench_desc') }}</p>
          </div>
          <div class="flex items-center space-x-4">
            <div class="flex items-center space-x-2">
              <div class="w-3 h-3 bg-purple-500 rounded-full animate-pulse"></div>
              <span class="text-sm text-gray-600">{{ $store.getters.t('video_workbench_running') }}</span>
            </div>
            <button class="bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 transition-colors">
              <i class="fas fa-plus mr-2"></i>
              {{ $store.getters.t('new_video_project') }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <!-- 视频制作概览卡片 -->
      <div class="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
        <div class="bg-white rounded-lg shadow-sm border p-6">
          <div class="flex items-center justify-between">
            <div>
              <p class="text-sm font-medium text-gray-600">{{ $store.getters.t('material_library') }}</p>
              <p class="text-2xl font-bold text-gray-900">1,234</p>
            </div>
            <div class="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center">
              <i class="fas fa-images text-purple-600 text-xl"></i>
            </div>
          </div>
          <div class="mt-4">
            <span class="text-xs text-purple-600 bg-purple-100 px-2 py-1 rounded-full">{{ $store.getters.t('increase_this_week') }}</span>
          </div>
        </div>

        <div class="bg-white rounded-lg shadow-sm border p-6">
          <div class="flex items-center justify-between">
            <div>
              <p class="text-sm font-medium text-gray-600">{{ $store.getters.t('auto_editing') }}</p>
              <p class="text-2xl font-bold text-gray-900">89</p>
            </div>
            <div class="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
              <i class="fas fa-cut text-blue-600 text-xl"></i>
            </div>
          </div>
          <div class="mt-4">
            <span class="text-xs text-blue-600 bg-blue-100 px-2 py-1 rounded-full">{{ $store.getters.t('ai_driven') }}</span>
          </div>
        </div>

        <div class="bg-white rounded-lg shadow-sm border p-6">
          <div class="flex items-center justify-between">
            <div>
              <p class="text-sm font-medium text-gray-600">{{ $store.getters.t('platform_distribution') }}</p>
              <p class="text-2xl font-bold text-gray-900">156</p>
            </div>
            <div class="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
              <i class="fas fa-share-alt text-green-600 text-xl"></i>
            </div>
          </div>
          <div class="mt-4">
            <span class="text-xs text-green-600 bg-green-100 px-2 py-1 rounded-full">{{ $store.getters.t('multi_platform') }}</span>
          </div>
        </div>

        <div class="bg-white rounded-lg shadow-sm border p-6">
          <div class="flex items-center justify-between">
            <div>
              <p class="text-sm font-medium text-gray-600">{{ $store.getters.t('play_volume') }}</p>
              <p class="text-2xl font-bold text-gray-900">2.3M</p>
            </div>
            <div class="w-12 h-12 bg-yellow-100 rounded-lg flex items-center justify-center">
              <i class="fas fa-play text-yellow-600 text-xl"></i>
            </div>
          </div>
          <div class="mt-4">
            <span class="text-xs text-yellow-600 bg-yellow-100 px-2 py-1 rounded-full">{{ $store.getters.t('increase_this_month') }}</span>
          </div>
        </div>
      </div>

      <!-- 主要功能区域 -->
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <!-- 素材管理 -->
        <div class="bg-white rounded-lg shadow-sm border p-6">
          <div class="flex items-center justify-between mb-4">
            <h3 class="text-lg font-semibold text-gray-900 flex items-center">
              <i class="fas fa-images mr-2 text-purple-500"></i>
              {{ $store.getters.t('material_management') }}
            </h3>
            <button class="text-xs bg-purple-100 text-purple-800 px-2 py-1 rounded-full hover:bg-purple-200">
              <i class="fas fa-plus mr-1"></i>
              {{ $store.getters.t('upload_material') }}
            </button>
          </div>
          <div class="space-y-4">
            <div class="p-4 bg-purple-50 rounded-lg">
              <div class="flex items-center justify-between mb-2">
                <span class="font-medium text-gray-900">{{ $store.getters.t('live_screen_recording') }}</span>
                <span class="text-xs bg-purple-200 text-purple-800 px-2 py-1 rounded">{{ $store.getters.t('hot') }}</span>
              </div>
              <div class="text-sm text-gray-600">{{ $store.getters.t('live_recording_material') }}</div>
              <div class="mt-2 text-xs text-gray-500">{{ $store.getters.t('file_count') }}: 45</div>
            </div>
            <div class="p-4 bg-purple-50 rounded-lg">
              <div class="flex items-center justify-between mb-2">
                <span class="font-medium text-gray-900">{{ $store.getters.t('background_music') }}</span>
                <span class="text-xs bg-blue-200 text-blue-800 px-2 py-1 rounded">{{ $store.getters.t('recommend') }}</span>
              </div>
              <div class="text-sm text-gray-600">{{ $store.getters.t('copyright_music_library') }}</div>
              <div class="mt-2 text-xs text-gray-500">{{ $store.getters.t('file_count') }}: 128</div>
            </div>
            <div class="p-4 bg-purple-50 rounded-lg">
              <div class="flex items-center justify-between mb-2">
                <span class="font-medium text-gray-900">{{ $store.getters.t('effect_template') }}</span>
                <span class="text-xs bg-gray-200 text-gray-800 px-2 py-1 rounded">{{ $store.getters.t('normal') }}</span>
              </div>
              <div class="text-sm text-gray-600">{{ $store.getters.t('transition_effects') }}</div>
              <div class="mt-2 text-xs text-gray-500">{{ $store.getters.t('file_count') }}: 67</div>
            </div>
          </div>
        </div>

        <!-- 内容主题 -->
        <div class="bg-white rounded-lg shadow-sm border p-6">
          <div class="flex items-center justify-between mb-4">
            <h3 class="text-lg font-semibold text-gray-900 flex items-center">
              <i class="fas fa-lightbulb mr-2 text-yellow-500"></i>
              {{ $store.getters.t('content_theme') }}
            </h3>
            <span class="text-xs bg-yellow-100 text-yellow-800 px-2 py-1 rounded-full">{{ $store.getters.t('ai_generated') }}</span>
          </div>
          <div class="space-y-4">
            <div class="p-4 bg-yellow-50 rounded-lg">
              <div class="flex items-center justify-between mb-2">
                <span class="font-medium text-gray-900">{{ $store.getters.t('hot_topic') }}</span>
                <span class="text-xs bg-yellow-200 text-yellow-800 px-2 py-1 rounded">{{ $store.getters.t('hot') }}</span>
              </div>
              <div class="text-sm text-gray-600">{{ $store.getters.t('content_theme_based_on_hot_search') }}</div>
              <div class="mt-2 text-xs text-gray-500">{{ $store.getters.t('hot_degree') }}: 95%</div>
            </div>
            <div class="p-4 bg-yellow-50 rounded-lg">
              <div class="flex items-center justify-between mb-2">
                <span class="font-medium text-gray-900">{{ $store.getters.t('emotional_resonance') }}</span>
                <span class="text-xs bg-blue-200 text-blue-800 px-2 py-1 rounded">{{ $store.getters.t('recommend') }}</span>
              </div>
              <div class="text-sm text-gray-600">{{ $store.getters.t('content_theme_for_emotional_resonance') }}</div>
              <div class="mt-2 text-xs text-gray-500">{{ $store.getters.t('resonance_degree') }}: 87%</div>
            </div>
            <div class="p-4 bg-yellow-50 rounded-lg">
              <div class="flex items-center justify-between mb-2">
                <span class="font-medium text-gray-900">{{ $store.getters.t('knowledge_sharing') }}</span>
                <span class="text-xs bg-gray-200 text-gray-800 px-2 py-1 rounded">{{ $store.getters.t('normal') }}</span>
              </div>
              <div class="text-sm text-gray-600">{{ $store.getters.t('education_and_skill_sharing_theme') }}</div>
              <div class="mt-2 text-xs text-gray-500">{{ $store.getters.t('educational_value') }}: 78%</div>
            </div>
          </div>
        </div>

        <!-- 自动剪辑 -->
        <div class="bg-white rounded-lg shadow-sm border p-6">
          <div class="flex items-center justify-between mb-4">
            <h3 class="text-lg font-semibold text-gray-900 flex items-center">
              <i class="fas fa-cut mr-2 text-blue-500"></i>
              {{ $store.getters.t('auto_editing') }}
            </h3>
            <span class="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded-full">{{ $store.getters.t('ai_driven') }}</span>
          </div>
          <div class="space-y-4">
            <div class="p-4 bg-blue-50 rounded-lg">
              <div class="flex items-center justify-between mb-2">
                <span class="font-medium text-gray-900">{{ $store.getters.t('smart_segmentation') }}</span>
                <span class="text-xs bg-blue-200 text-blue-800 px-2 py-1 rounded">{{ $store.getters.t('in_progress') }}</span>
              </div>
              <div class="text-sm text-gray-600">{{ $store.getters.t('ai_automatically_identifies_interesting_segments_and_segments') }}</div>
              <div class="mt-2 text-xs text-gray-500">{{ $store.getters.t('processing') }}: 3</div>
            </div>
            <div class="p-4 bg-blue-50 rounded-lg">
              <div class="flex items-center justify-between mb-2">
                <span class="font-medium text-gray-900">{{ $store.getters.t('auto_music_matching') }}</span>
                <span class="text-xs bg-green-200 text-green-800 px-2 py-1 rounded">{{ $store.getters.t('completed') }}</span>
              </div>
              <div class="text-sm text-gray-600">{{ $store.getters.t('automatically_matches_background_music_based_on_content') }}</div>
              <div class="mt-2 text-xs text-gray-500">{{ $store.getters.t('completed') }}: 12</div>
            </div>
            <div class="p-4 bg-blue-50 rounded-lg">
              <div class="flex items-center justify-between mb-2">
                <span class="font-medium text-gray-900">{{ $store.getters.t('effect_addition') }}</span>
                <span class="text-xs bg-gray-200 text-gray-800 px-2 py-1 rounded">{{ $store.getters.t('pending') }}</span>
              </div>
              <div class="text-sm text-gray-600">{{ $store.getters.t('automatically_adds_transitions_filters_and_subtitles') }}</div>
              <div class="mt-2 text-xs text-gray-500">{{ $store.getters.t('queue') }}: 8</div>
            </div>
          </div>
        </div>

        <!-- 自动生成 -->
        <div class="bg-white rounded-lg shadow-sm border p-6">
          <div class="flex items-center justify-between mb-4">
            <h3 class="text-lg font-semibold text-gray-900 flex items-center">
              <i class="fas fa-magic mr-2 text-green-500"></i>
              {{ $store.getters.t('auto_generation') }}
            </h3>
            <span class="text-xs bg-green-100 text-green-800 px-2 py-1 rounded-full">{{ $store.getters.t('ai_creation') }}</span>
          </div>
          <div class="space-y-4">
            <div class="p-4 bg-green-50 rounded-lg">
              <div class="flex items-center justify-between mb-2">
                <span class="font-medium text-gray-900">{{ $store.getters.t('title_generation') }}</span>
                <span class="text-xs bg-green-200 text-green-800 px-2 py-1 rounded">{{ $store.getters.t('generating') }}</span>
              </div>
              <div class="text-sm text-gray-600">{{ $store.getters.t('ai_generates_attractive_video_titles') }}</div>
              <div class="mt-2 text-xs text-gray-500">{{ $store.getters.t('generated') }}: 15</div>
            </div>
            <div class="p-4 bg-green-50 rounded-lg">
              <div class="flex items-center justify-between mb-2">
                <span class="font-medium text-gray-900">{{ $store.getters.t('subtitle_generation') }}</span>
                <span class="text-xs bg-green-200 text-green-800 px-2 py-1 rounded">{{ $store.getters.t('completed') }}</span>
              </div>
              <div class="text-sm text-gray-600">{{ $store.getters.t('automatically_generates_subtitles_from_speech_recognition') }}</div>
              <div class="mt-2 text-xs text-gray-500">{{ $store.getters.t('completed') }}: 23</div>
            </div>
            <div class="p-4 bg-green-50 rounded-lg">
              <div class="flex items-center justify-between mb-2">
                <span class="font-medium text-gray-900">{{ $store.getters.t('cover_generation') }}</span>
                <span class="text-xs bg-gray-200 text-gray-800 px-2 py-1 rounded">{{ $store.getters.t('pending') }}</span>
              </div>
              <div class="text-sm text-gray-600">{{ $store.getters.t('ai_generates_video_cover_images') }}</div>
              <div class="mt-2 text-xs text-gray-500">{{ $store.getters.t('queue') }}: 6</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 平台分发 -->
      <div class="bg-white rounded-lg shadow-sm border p-6 mt-8">
        <div class="flex items-center justify-between mb-6">
          <h3 class="text-lg font-semibold text-gray-900">{{ $store.getters.t('platform_distribution') }}</h3>
          <div class="flex space-x-2">
            <button class="bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 transition-colors text-sm">
              <i class="fas fa-plus mr-1"></i>
              {{ $store.getters.t('new_distribution_task') }}
            </button>
          </div>
        </div>
        
        <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div class="p-4 bg-red-50 rounded-lg border border-red-200">
            <div class="flex items-center justify-between mb-2">
              <h4 class="font-medium text-gray-900">{{ $store.getters.t('douyin') }}</h4>
              <span class="text-xs bg-red-200 text-red-800 px-2 py-1 rounded">{{ $store.getters.t('distributed') }}</span>
            </div>
            <div class="text-sm text-gray-600">{{ $store.getters.t('short_video_platform_distribution') }}</div>
            <div class="mt-2 text-xs text-gray-500">{{ $store.getters.t('play_volume') }}: 156K</div>
          </div>
          
          <div class="p-4 bg-blue-50 rounded-lg border border-blue-200">
            <div class="flex items-center justify-between mb-2">
              <h4 class="font-medium text-gray-900">{{ $store.getters.t('kuaishou') }}</h4>
              <span class="text-xs bg-blue-200 text-blue-800 px-2 py-1 rounded">{{ $store.getters.t('distributed') }}</span>
            </div>
            <div class="text-sm text-gray-600">{{ $store.getters.t('short_video_platform_distribution') }}</div>
            <div class="mt-2 text-xs text-gray-500">{{ $store.getters.t('play_volume') }}: 89K</div>
          </div>
          
          <div class="p-4 bg-green-50 rounded-lg border border-green-200">
            <div class="flex items-center justify-between mb-2">
              <h4 class="font-medium text-gray-900">{{ $store.getters.t('video_number') }}</h4>
              <span class="text-xs bg-green-200 text-green-800 px-2 py-1 rounded">{{ $store.getters.t('distributed') }}</span>
            </div>
            <div class="text-sm text-gray-600">{{ $store.getters.t('wechat_video_number_distribution') }}</div>
            <div class="mt-2 text-xs text-gray-500">{{ $store.getters.t('play_volume') }}: 234K</div>
          </div>
        </div>
      </div>

      <!-- 结果分析 -->
      <div class="bg-white rounded-lg shadow-sm border p-6 mt-8">
        <div class="flex items-center justify-between mb-6">
          <h3 class="text-lg font-semibold text-gray-900">{{ $store.getters.t('result_analysis') }}</h3>
          <div class="flex space-x-2">
            <select class="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:border-purple-500">
              <option>{{ $store.getters.t('last_7_days') }}</option>
              <option>{{ $store.getters.t('last_30_days') }}</option>
              <option>{{ $store.getters.t('last_90_days') }}</option>
            </select>
            <button class="bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 transition-colors text-sm">
              <i class="fas fa-chart-bar mr-1"></i>
              {{ $store.getters.t('generate_report') }}
            </button>
          </div>
        </div>
        
        <div class="grid grid-cols-1 md:grid-cols-4 gap-6">
          <div class="text-center p-4 bg-purple-50 rounded-lg">
            <div class="text-2xl font-bold text-purple-600">2.3M</div>
            <div class="text-sm text-gray-600">{{ $store.getters.t('total_play_volume') }}</div>
          </div>
          <div class="text-center p-4 bg-blue-50 rounded-lg">
            <div class="text-2xl font-bold text-blue-600">156K</div>
            <div class="text-sm text-gray-600">{{ $store.getters.t('new_fans') }}</div>
          </div>
          <div class="text-center p-4 bg-green-50 rounded-lg">
            <div class="text-2xl font-bold text-green-600">89%</div>
            <div class="text-sm text-gray-600">{{ $store.getters.t('completion_rate') }}</div>
          </div>
          <div class="text-center p-4 bg-yellow-50 rounded-lg">
            <div class="text-2xl font-bold text-yellow-600">¥45K</div>
            <div class="text-sm text-gray-600">{{ $store.getters.t('revenue_analysis') }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VideoWorkbench',
  data() {
    return {
      // 可以添加数据
    }
  },
  methods: {
    // 可以添加方法
  }
}
</script>

<style scoped>
/* 可以添加样式 */
</style> 